import React, { useEffect, useState } from "react";

import { ShowError } from "../../../components/error";
import { Title } from "./title";
import { Value } from "./value";
import { fetchHcfDetails } from "./api";
import { Stack } from "@mui/material";
import { showErrorToast } from "@src/appV2/lib/Notifications";

function LateCancelCharge({ hcfId, updateFacility }) {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [details, setDetails] = useState<any>();
  const [error, setError] = useState();

  useEffect(() => {
    fetchHcfDetails(hcfId, "lateCancellation").then(setDetails).catch(setError);
  }, [hcfId]);

  const updateLocal = (data) => {
    setDetails((prev) => ({
      ...prev,
      lateCancellation: data.facility.lateCancellation,
    }));
  };

  const handleChange = (data) => {
    updateFacility({
      facilityId: hcfId,
      lateCancellation: data,
    })
      .then(updateLocal)
      .catch(() => showErrorToast("Unable to update workplace late cancel config"));
  };

  return (
    <Stack>
      <Title>Shift Late Cancel Charge</Title>
      <ShowError error={error} message="Unable to fetch workplace Late Cancel Charge" />
      <p className="content">
        Shift cancelled within
        <Value name="period" onChange={handleChange} value={details?.lateCancellation?.period} />
        hrs of shift start will be billed for
        <Value
          name="feeHours"
          onChange={handleChange}
          value={details?.lateCancellation?.feeHours}
        />
        hrs at the Workplace Total Charge.
      </p>
    </Stack>
  );
}

export { LateCancelCharge };
